
import { defineComponent, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { downloadHistory } from '@/api/profile'

export default defineComponent({
  setup() {
    const store = useStore()
    const recentHistories = ref([] as any)
    const restHistories = ref([] as any)
    const isShowAll = ref(false)

    const asyncGetDownloadHistory = async () => {
      const res = await downloadHistory()
      if (res.status) {
        recentHistories.value = res.data.recentHistories
        restHistories.value = res.data.restHistories
        if (
          res.data.restHistories.length === 0 ||
          res.data.recentHistories.length === 0
        ) {
          isShowAll.value = true
          recentHistories.value =
            res.data.recentHistories.length > 0
              ? res.data.recentHistories
              : res.data.restHistories
        }
      }
    }
    onMounted(() => {
      asyncGetDownloadHistory()
    })
    return {
      store,
      recentHistories,
      restHistories,
      asyncGetDownloadHistory,
      isShowAll,
    }
  },
})
